module.exports = __webpack_public_path__ + "static/media/chinese_delivery_2.36b2bede.png";